import { useId } from 'react';

/**
 * A multi-line field.
 *
 * twreact-ui has no Textarea, and its Input renders a single-line `<input>`, so
 * this is written locally rather than faked — matched to the library's Input
 * markup (label, control, error line) so a form built from both reads as one.
 */
export default function Textarea({ label, error, hint, id, className = '', rows = 3, ...rest }) {
  const generated = useId();
  const fieldId = id || `textarea-${generated}`;

  return (
    <div className="w-full">
      {label ? (
        <label htmlFor={fieldId} className="mb-1.5 block text-sm font-medium text-[var(--app-text)]">
          {label}
        </label>
      ) : null}
      <textarea
        id={fieldId}
        rows={rows}
        aria-invalid={!!error}
        aria-describedby={error ? `${fieldId}-error` : hint ? `${fieldId}-hint` : undefined}
        className={`w-full rounded-lg border bg-[var(--app-surface)] px-3 py-2 text-sm text-[var(--app-text)] outline-none transition-colors placeholder:text-[var(--app-muted)] focus:border-primary-500 focus:ring-2 focus:ring-primary-500/30 ${
          error ? 'border-error-500' : 'border-[var(--app-border)]'
        } ${className}`}
        {...rest}
      />
      {error ? (
        <p id={`${fieldId}-error`} className="mt-1 text-xs text-error-600">
          {error}
        </p>
      ) : hint ? (
        <p id={`${fieldId}-hint`} className="mt-1 text-xs text-[var(--app-muted)]">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
